/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

// Product Name
export const PRODUCT_NAME = 'WSO2 Developer Platform';
export const SUPPORT_PRICE = 0;
export const STEP_BASED_FREE_TIER = 'Free';
export const DEVELOPER_TIER = 'Developer';
export const ESSENTIALS_TIER = 'Essentials';
export const PROFESSIONAL_TIER = 'Professional';
export const ENTERPRISE_TIER = 'Enterprise';
export const NON_CORPORATE_EMAIL = 'non-corporate';
export const FREE_TIER = 'Free';
export const FREE_V2_TIER = 'FreeV2';
export const TEAM_TIER = 'Team';
export const CHOREO_SUPPORT_TIER = 'Support';
export const BIJIRA_STARTER_TIER = 'Starter';
export const BIJIRA_FREE_TRIAL_TIER_LABEL = '30-Day Free Trial';
export const BIJIRA_FREE_TRIAL_TIER = 'Free Trial';
export const BIJIRA_PAYG_TIER = 'Pay-As-You-Go';
export const BIJIRA_PAYG_TIER_WITH_SUPPORT = 'Pay-As-You-Go with Support';
export const BIJIRA_SUPPORT_TIER = 'Support';
export const DEVANT_SUPPORT_TIER = 'Support';
export const BIJIRA_ENTERPRISE_TIER = 'Enterprise';
export const DEVANT_STARTER_TIER = 'Starter';
export const DEVANT_PAYG_TIER = 'Pay-As-You-Go';
export const DEVANT_ENTERPRISE_TIER = 'Enterprise';
export const TEAM_WITH_SUPPORT_TIER = 'Team with Support';
export const FREE_TRIAL_TIER = 'Free Trial';
export const READ_ONLY_TIER = 'Read-Only';
export const SUBSCRIPTION_STATUS_CANCELLATION_PENDING = 'cancellation-pending';
export const BILLING_PROVIDER_STRIPE = 'stripe';
export const BILLING_PROVIDER_AZURE = 'azure';
export const BILLING_PROVIDER_AWS = 'aws';
export const BILLING_PROVIDER_GCP = 'gcp';
export const AWS_MARKETPLACE_LINK =
  'https://aws.amazon.com/marketplace/pp/prodview-rgocnkozrtpgk';
export const GCP_MARKETPLACE_LINK = 'https://cloud.google.com/marketplace';
export const AZURE_PORTAL_SAAS_LINK =
  'https://portal.azure.com/#view/HubsExtension/' +
  'BrowseResourceBlade/resourceType/Microsoft.SaaS%2Fresources';
export const AZURE_PORTAL_BILLING_LINK =
  'https://portal.azure.com/#view/Microsoft_Azure_CostManagement/Menu/' +
  '~/invoices';
export const INVALID_TELEPHONE_NUMBER_ERROR = 'Invalid telephone number.';
export const CHOREO_PRICING_LINK = 'https://wso2.com/choreo/pricing/';
export const BIJIRA_PRICING_LINK = 'https://wso2.com/bijira/pricing/';
export const DEVANT_PRICING_LINK = 'https://wso2.com/devant/pricing/';
export const ASGARDEO_PRICING_LINK = 'https://wso2.com/asgardeo/pricing/';
export const ASGARDEO_SUPPORT_COMPARE_LINK =
  'https://wso2.com/saas-support-plans/#ComparePlans';
